export enum MeasurementType {
    Unknown = 0,
    Form = 1,
    ImageSelection = 2,
}